import { BlockScrollStrategy, ViewportRuler } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MvdScrollStrategy extends BlockScrollStrategy {
    private root: HTMLElement;
    private modalRefCount: number;

    constructor(viewportRuler: ViewportRuler, @Inject(DOCUMENT) document) {
        super(viewportRuler, document);
        this.root = document.documentElement;
        this.modalRefCount = 0;
    }

    attach() {
        super.attach();
        this.modalRefCount++;
    }

    enable() {
        this.modalRefCount++;
        this.addScrollBlock();
    }

    disable() {
        if (this.modalRefCount > 0) {
            this.modalRefCount--;

            if (this.modalRefCount === 0) {
                this.removeScrollBlock();
            }
        }
    }

    reset() {
        this.modalRefCount = 0;
        this.removeScrollBlock();
        window.scroll(0, 0);
    }

    private addScrollBlock() {
        super.enable();
        this.root.classList.add('cdk-global-scrollblock');
    }

    private removeScrollBlock() {
        super.disable();
        this.root.classList.remove('cdk-global-scrollblock');
    }
}
